import { render } from "./index.vue?vue&type=template&id=40a787e0&scoped=true"
import script from "./editor-heading.js?vue&type=script&lang=js"
export * from "./editor-heading.js?vue&type=script&lang=js"

import "./editor-heading.scss?vue&type=style&index=0&id=40a787e0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\devin\\Desktop\\Web\\Portfolios\\Portolio\\vue-personal-portfolio\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a787e0"]])

export default __exports__